import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {Util} from './app/utils/utils';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = () => {
    };
  }
}
fetch('api/v1/util/dados-ad', {
  method: 'GET',
}).then(
  (response) => {
    response.json().then((data) => {
      Util.azureAdCoinfigs = data;
    });
  }
).then(() => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});

